import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { FAIcon } from 'lib/customPropTypes';

const Icon = ({ alt, icon, ...rest }) => (
  <Fragment>
    {alt ? <span className="sr-only">{alt}</span> : null}
    <FontAwesomeIcon icon={icon} {...rest} />
  </Fragment>
);

Icon.defaultProps = {
  alt: '',
};

Icon.propTypes = {
  alt: PropTypes.string,
  icon: FAIcon.isRequired,
};

export default Icon;
